import { useState } from 'react';
import { OnlineShops } from '../../screens';
import Shops from '../../screens/shops/Shops';
import { GeolocationContextProvider } from '../../contexts/GeolocationContext';
import { ShopsContextProvider, useShopsContext } from '../shops/contexts/ShopsContext';
import SupportTypeBar from '../shops/components/supportTypeBar/SupportTypeBar';
import ConvocationModal from '../shops/components/convocationModal/ConvocationModal';
import './PublicShops.scss';

const PublicShops = () => {
    return (
        <div className="PublicShops">
            <div className="PublicShops__content">
                <div className="w-100 d-flex justify-content-center">
                    <div className="PublicShops__content__title">
                        <h6 className="text-center">Entidades adheridas</h6>
                    </div>
                </div>
                <ShopsContextProvider fromPublic>
                    <PublicShopsContent />
                </ShopsContextProvider>
            </div>
        </div>
    );
}

const PublicShopsContent = () => {
    const [mode, setMode] = useState('physical');
    const { showSupportTypeFilters, selectedSupportType, setSelectedSupportType, modalDismissed } = useShopsContext();

    return (
        <>
            {!modalDismissed && <ConvocationModal />}
            <div className='PublicShops__content__tabs'>
                <div className={`PublicShops__content__tabs__item ${mode === 'physical' ? 'selected' : ''}`} onClick={() => setMode('physical')}>Con puntos de venta</div>
                <div className={`PublicShops__content__tabs__item ${mode === 'online' ? 'selected' : ''}`} onClick={() => setMode('online')}>De venta online</div>
                {showSupportTypeFilters && (
                    <div className='PublicShops__content__tabs__supportType'>
                        <SupportTypeBar selectedSupportType={selectedSupportType} onChange={setSelectedSupportType} />
                    </div>
                )}
            </div>
            {mode === 'physical' ? (
                <GeolocationContextProvider>
                    <Shops fromPublic contextProvided />
                </GeolocationContextProvider>
            ) : (
                <OnlineShops fromPublic supportType={selectedSupportType} />
            )}
        </>
    );
}

export default PublicShops;
